import Pager from '@/shared/pager/pager';

export default {
  build: () => {
    const keysToSearch = [
      'name'
    ];

    const exportDefinitions = [
      // { value: 'id', label: 'id' },
      { value: 'name', label: 'name' },
    ];

    return new Pager(keysToSearch, exportDefinitions);
  }
};



// WEBPACK FOOTER //
// ./src/entities/document/document-pager.js